import React from 'react'
import styled from 'styled-components'

import { SessionDataBridge } from './components/SessionDataBridge'
import { SessionHeaderBar } from './components/SessionHeaderBar'
import { ChatbotSessionProvider } from './contexts/ChatbotSessionContext'

const ChatbotContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

/**
 * Chatbot UI without its own session provider. Use this when an
 * outer `<ChatbotSessionProvider>` is already in scope (e.g. so a
 * page-level button can reach `createSession`). Otherwise mount
 * `<Chatbot>` which wraps this in a provider.
 */
export const ChatbotInner: React.FC = () => {
  return (
    <ChatbotContainer>
      <SessionHeaderBar />
      <SessionDataBridge />
    </ChatbotContainer>
  )
}

interface ChatbotProps {
  onClose?: () => void
  useV2?: boolean
  /**
   * When true, render `<ChatbotInner>` only — assume an outer
   * `<ChatbotSessionProvider>` is already mounted. Used by the case
   * page so its "Ask about this case" button (which lives outside
   * the chat panel) can call `createSession({ mode, context })`.
   */
  useExistingProvider?: boolean
}

export const Chatbot: React.FC<ChatbotProps> = ({
  useV2 = false,
  useExistingProvider = false,
}) => {
  if (useExistingProvider) {
    return <ChatbotInner />
  }
  return (
    <ChatbotSessionProvider useV2={useV2}>
      <ChatbotInner />
    </ChatbotSessionProvider>
  )
}
